import { generateOptionValueFromEntity } from 'components/PlatformResourceSelector/utils';
import { NextRouter } from 'next/router';

export const getOpenModelInPlaygroundUrl = (model: CF.API.Models.Model) => {
  const currentQueryId = generateOptionValueFromEntity(model as unknown as CF.API.Models.Model);
  return `/playground?model=${currentQueryId}&user_id=${model.user_id}&app_id=${model.app_id}`;
};

export const handleOpenInPlayground = (model: CF.API.Models.Model, router: NextRouter) => {
  if (!model) return;

  router.push(getOpenModelInPlaygroundUrl(model));
};

export const getTextCapitalize = (text: string) => {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
